if (!customElements.get('search-drawer')) {
  customElements.define(
    'search-drawer',
    class SearchDrawer extends DrawerElement {
      constructor() {
        super();
      }

      get shouldAppendToBody() {
        return false;
      }

      get input() {
        return this.querySelector('input[type="search"]');
      }

      get focusElement() {
        return this.querySelector('input[type="search"]');
      }
    }
  );
}

if (!customElements.get('search-typed')) {
  customElements.define(
    'search-typed',
    class SearchTyped extends HTMLElement {
      constructor() {
        super();

        Motion.inView(this, this.init.bind(this));
      }

      get startDelay() {
        return this.hasAttribute('data-delay') ? parseFloat(this.getAttribute('data-delay')) : 0;
      }

      async init() {
        this.insertCursor();
        await this.start(this.getAttribute('data-first-text'), this.startDelay);

        setTimeout(async () => {
          await this.reset();
          await this.start(this.getAttribute('data-last-text'), 0);
        }, 600);
      }

      async start(text, delay) {
        this.innerHTML = text;
        await Motion.animate(this, { width: [0, `${this.scrollWidth}px`] }, { duration: 1, delay }).finished;
        this.cursor.classList.add('blink');
      }

      async reset() {
        this.cursor.classList.remove('blink');
        await Motion.animate(this, { width: 0 }, { duration: 0.25 }).finished;
      }

      insertCursor() {
        if (this.cursor) return;

        this.cursor = document.createElement('span');
        this.cursor.className = 'typed-cursor';
        this.cursor.setAttribute('aria-hidden', true);
        this.cursor.innerHTML = '|';
        this.parentElement.insertBefore(this.cursor, this.nextSibling);
      }
    }
  );
}

if (!customElements.get('predictive-search')) {
  customElements.define(
    'predictive-search',
    class PredictiveSearch extends HTMLFormElement {
      constructor() {
        super();

        this.cachedMap = new Map();
        this.focusElement = this.input;

        this.resetButton.addEventListener('click', this.clear.bind(this));
        this.input.addEventListener('click', this.hideTypewriter.bind(this));
        this.input.addEventListener('input', theme.utils.debounce(this.onChange.bind(this), 300));
        this.input.addEventListener('focus', this.onFocus.bind(this));
      }

      get input() {
        return this.querySelector('input[type="search"]');
      }

      get resetButton() {
        return this.querySelector('button[type="reset"]');
      }

      get typewriter() {
        return this.input.previousElementSibling;
      }

      hideTypewriter() {
        if (this.typewriter && !this.typewriter.hasAttribute('hidden')) {
          this.typewriter.setAttribute('hidden', '');
        }
      }

      onFocus(event) {
        if (this.closest('.collection')) {
          document.body.classList.add('predictive-search-open');

          const searchTerm = this.getQuery();
          if (searchTerm.length === 0) return;

          const url = this.buildUrl().toString();
          this.renderSection(url, event);
        }
      }

      clear(event = null) {
        if (event) event.preventDefault();

        this.input.value = '';
        this.input.focus();
        this.removeAttribute('results');
      }

      getQuery() {
        return this.input.value.trim();
      }

      buildUrl() {
        const url = new URL(`${theme.routes.shop_url}${theme.routes.predictive_search_url}`);

        url.searchParams.set('q', this.getQuery());
        url.searchParams.set('resources[limit]', this.hasAttribute('data-limit') ? parseInt(this.getAttribute('data-limit')) : 3);
        url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('section_id', theme.utils.sectionId(this));
        return url;
      }

      onChange() {
        if (this.getQuery().length === 0) {
          this.clear();
          return;
        }

        this.hideTypewriter();

        const url = this.buildUrl().toString();
        this.renderSection(url);
      }

      renderSection(url) {
        this.cachedMap.has(url)
          ? this.renderSectionFromCache(url)
          : this.renderSectionFromFetch(url);
      }

      renderSectionFromCache(url) {
        const responseText = this.cachedMap.get(url);
        this.renderSearchResults(responseText);

        this.setAttribute('results', '');
      }

      renderSectionFromFetch(url) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        
        this.setAttribute('loading', '');

        fetch(url, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.renderSearchResults(responseText);
            this.cachedMap.set(url, responseText);

            this.removeAttribute('loading');
            this.setAttribute('results', '');
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            }
            else {
              console.error(error);
            }
          });
      }

      renderSearchResults(responseText) {
        const id = 'PredictiveSearchResults-' + theme.utils.sectionId(this);
        if (document.getElementById(id) === null) return;

        document.getElementById(id).innerHTML = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .getElementById(id).innerHTML;
      }
    }, { extends: 'form' }
  );
}

if (!customElements.get('predictive-search-overlay')) {
  customElements.define(
    'predictive-search-overlay',
    class PredictiveSearchOverlay extends OverlayElement {
      constructor() {
        super();

        this.addEventListener('click', this.onClick);
      }

      onClick() {
        setTimeout(() => {
          document.body.classList.remove('predictive-search-open');
        });
      }
    }
  );
}
(function () {
  if (window.RogueSearchBoostLoaded) return;
  window.RogueSearchBoostLoaded = true;

  var cache = null;
  var promise = null;

  var brands = [
    ['Abercrombie & Fitch', ['Abercrombie', 'A&F', 'Fierce']],
    ['Acqua Di Parma', ['Aqua Di Parma', 'ADP']],
    ['Amouage', []],
    ['Armani', ['Giorgio Armani']],
    ['Azzaro', []],
    ['BDK', []],
    ['Boadicea The Victorious', ['Boadicea']],
    ['Bond No. 9', ['Bond No 9', 'Bond Number 9']],
    ['Born To Stand Out', ['BTSO']],
    ['Burberry', []],
    ['Bvlgari', ['Bulgari']],
    ['Byredo', []],
    ['Carolina Herrera', ['Good Girl', 'Bad Boy']],
    ['Cartier', []],
    ['Chanel', ['Channel', 'Bleu de Chanel', 'Bleu Chanel', 'Blue Chanel']],
    ['Chloe', ['Chloé']],
    ['Clive Christian', []],
    ['Creed', ['Aventus']],
    ['Dior', ['Sauvage', 'Savage']],
    ['Diptyque', []],
    ['Dolce & Gabbana', ['Dolce Gabbana', 'D&G', 'DG']],
    ['Ex Nihilo', []],
    ['Fragrance Du Bois', ['FDB']],
    ['Frederic Malle', ['Frédéric Malle']],
    ['Gissah', []],
    ['Gucci', []],
    ['Guerlain', []],
    ['Initio', []],
    ['Jean Paul Gaultier', ['JPG']],
    ['Jo Malone', []],
    ['Kayali', []],
    ['Kilian', ['Killian', 'By Kilian']],
    ['Lancome', ['Lancôme']],
    ['Le Labo', ['Lelabo', 'Santal 33']],
    ['Louis Vuitton', ['LV', 'L V', 'Ombre Nomade']],
    ['Maison Francis Kurkdjian', ['MFK', 'Baccarat', 'Baccarat Rouge 540', 'BR540']],
    ['Memo Paris', ['Memo']],
    ['Mind Games', []],
    ['Montale', []],
    ['Montblanc', ['Mont Blanc']],
    ['Mugler', []],
    ['Nasomatto', []],
    ['Nishane', []],
    ['Orto Parisi', []],
    ['Paco Rabanne', ['Rabanne', '1 Million', 'One Million', 'Lady Million']],
    ['Parfums de Marly', ['PDM', 'Parfums de Marley']],
    ["Penhaligon's", ['Penhaligon', 'Penhaligons']],
    ['Prada', []],
    ['Roja', ['Roja Dove']],
    ['Stephane Humbert Lucas', ['SHL']],
    ['Tom Ford', ['TF', 'Oud Wood']],
    ['Valentino', []],
    ['Versace', []],
    ['Viktor & Rolf', ['Victor & Rolf', 'Spicebomb', 'Flowerbomb']],
    ['Widian', []],
    ['Xerjoff', []],
    ['Yves Saint Laurent', ['YSL', 'Y S L']]
  ];

  function norm(v) {
    return String(v || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function has(text, phrase) {
    return (' ' + norm(text) + ' ').indexOf(' ' + norm(phrase) + ' ') !== -1;
  }

  function stripHtml(html) {
    var div = document.createElement('div');
    div.innerHTML = String(html || '');
    return div.textContent || div.innerText || '';
  }

  function getTags(product) {
    if (!product || !product.tags) return [];
    if (Array.isArray(product.tags)) return product.tags;

    return String(product.tags)
      .split(',')
      .map(function (tag) {
        return tag.trim();
      })
      .filter(Boolean);
  }

  function cleanInspiredBy(v) {
    var text = String(v || '')
      .replace(/\s+/g, ' ')
      .replace(/^inspired\s+by\s*:?\s*/i, '')
      .replace(/^the\s+scent\s+profile\s+of\s+/i, '')
      .replace(/^scent\s+profile\s+of\s+/i, '')
      .replace(/^profile\s+of\s+/i, '')
      .trim();

    var lower = text.toLowerCase();
    var markers = [
      ', this fragrance',
      ', it is',
      ', built',
      ', with notes',
      ', featuring',
      ' this fragrance',
      ' it is',
      ' is built',
      ' with notes',
      ' featuring notes',
      ' opens with',
      ' fragrance is'
    ];

    var cutAt = -1;

    markers.forEach(function (marker) {
      var index = lower.indexOf(marker);
      if (index > 0 && (cutAt === -1 || index < cutAt)) cutAt = index;
    });

    if (cutAt > 0) text = text.slice(0, cutAt).trim();

    return text.replace(/[,\s]+$/, '').trim();
  }

  function getInspiredBy(product) {
    var tags = getTags(product);

    for (var i = 0; i < tags.length; i++) {
      var tag = tags[i];
      var lower = tag.toLowerCase();

      var patterns = [
        'inspired by:',
        'inspired_by:',
        'inspired-by:',
        'inspired by ',
        'inspired_by_',
        'inspired-by-',
        'inspired:',
        'profile:',
        'original:'
      ];

      for (var p = 0; p < patterns.length; p++) {
        if (lower.indexOf(patterns[p]) === 0) {
          return cleanInspiredBy(tag.slice(patterns[p].length));
        }
      }
    }

    var text = stripHtml(product.body_html || product.description || '');
    var match =
      text.match(/inspired\s+by\s*:?\s*(.{2,160})/i) ||
      text.match(/scent\s+profile\s+of\s+(.{2,160})/i);

    return match && match[1] ? cleanInspiredBy(match[1]) : '';
  }

  function tokenMatch(text, term) {
    var textTokens = norm(text).split(' ').filter(Boolean);
    var termTokens = norm(term).split(' ').filter(Boolean);

    if (!termTokens.length || termTokens.length > textTokens.length) return false;

    for (var i = 0; i <= textTokens.length - termTokens.length; i++) {
      var ok = true;

      for (var j = 0; j < termTokens.length; j++) {
        if (textTokens[i + j] !== termTokens[j]) {
          ok = false;
          break;
        }
      }

      if (ok) return true;
    }

    return false;
  }

  function getBrand(product, inspiredBy) {
    var tags = getTags(product).map(norm);
    var inspired = inspiredBy || '';
    var title = product.title || '';

    for (var i = 0; i < brands.length; i++) {
      var brandName = norm(brands[i][0]);
      if (tags.indexOf(brandName) !== -1) return brands[i][0];
    }

    for (var b = 0; b < brands.length; b++) {
      if (tokenMatch(inspired, brands[b][0]) || tokenMatch(title, brands[b][0])) return brands[b][0];

      var aliases = brands[b][1] || [];

      for (var a = 0; a < aliases.length; a++) {
        if (tokenMatch(inspired, aliases[a]) || tokenMatch(title, aliases[a])) return brands[b][0];
      }
    }

    return '';
  }

  function img(product) {
    var image = '';

    if (product.images && product.images.length) {
      image = typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
    } else if (product.featured_image) {
      image = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
    }

    if (!image) return '';
    if (image.indexOf('//') === 0) return 'https:' + image;
    return image.replace('http://', 'https://');
  }

  function aliases(text) {
    var out = [];

    if (has(text, '1 Trillion')) out.push('1 Million One Million Paco Rabanne 1 Million');
    if (has(text, 'Lady Trillion')) out.push('Lady Million Paco Rabanne Lady Million');
    if (has(text, 'Trillion Elixir')) out.push('1 Million Elixir Million Elixir');
    if (has(text, 'Trillion Private')) out.push('1 Million Prive Million Prive Million Private');
    if (has(text, 'Wild Elixir') || has(text, 'Savage')) out.push('Sauvage Dior Sauvage Sauvage Elixir Savage Elixir');
    if (has(text, 'Blue Channel') || has(text, 'Blue Chanel')) out.push('Bleu de Chanel Bleu Chanel Chanel Bleu Blue Chanel');
    if (has(text, 'BR540') || has(text, 'Baccarat')) out.push('Baccarat Rouge 540 Baccarat Rouge BR540 BR 540 Maison Francis Kurkdjian');
    if (has(text, 'Santal 34')) out.push('Santal 33 Santal Thirty Three Le Labo Santal 33');
    if (has(text, 'Oud Woods')) out.push('Oud Wood Tom Ford Oud Wood');
    if (has(text, 'Nomad Ombre') || has(text, 'Ombre Nomad')) out.push('Ombre Nomade Louis Vuitton Ombre Nomade');
    if (has(text, 'Good Glow')) out.push('Good Girl Carolina Herrera Good Girl');
    if (has(text, 'Bad Influence')) out.push('Bad Boy Carolina Herrera Bad Boy');
    if (has(text, 'The Only Gent')) out.push('The One Men The One Man Dolce Gabbana The One');
    if (has(text, 'The Only Femme')) out.push('The One Women The One Woman Dolce Gabbana The One');
    if (has(text, 'Stronger Together')) out.push('Stronger With You Armani Stronger With You');
    if (has(text, 'Hypnotic Spell')) out.push('Hypnotic Poison Dior Hypnotic Poison');
    if (has(text, 'Midnight Saffron')) out.push('Drunk Saffron Born To Stand Out Drunk Saffron');
    if (has(text, 'Crystal On The Rocks')) out.push('Vodka On The Rocks Kilian Vodka On The Rocks');

    return out.join(' ');
  }

  function isBundle(product) {
    var title = norm(product.title || '');
    var tags = norm(getTags(product).join(' '));
    return title.indexOf('bundle') !== -1 || title.indexOf('custom scent') !== -1 || tags.indexOf('bundle') !== -1;
  }

  function fetchPage(page) {
    return fetch('/collections/shop-all/products.json?limit=250&page=' + page)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        return data.products || [];
      });
  }

  function loadProducts() {
    if (cache) return Promise.resolve(cache);
    if (promise) return promise;

    promise = (async function () {
      var all = [];
      var page = 1;
      var pageProducts = [];

      do {
        pageProducts = await fetchPage(page);
        all = all.concat(pageProducts);
        page++;
      } while (pageProducts.length === 250 && page <= 10);

      cache = all
        .filter(function (p) {
          return p && p.title && !isBundle(p);
        })
        .map(function (p) {
          var inspired = getInspiredBy(p);
          var brand = getBrand(p, inspired);
          var tags = getTags(p).join(' ');
          var full = [p.title, p.handle, inspired, brand, tags].join(' ');

          return {
            title: p.title,
            url: '/products/' + p.handle,
            image: img(p),
            brand: brand,
            inspired: inspired,
            searchable: norm(full + ' ' + aliases(full))
          };
        });

      return cache;
    })();

    return promise;
  }

  function styles() {
    if (document.getElementById('rs-search-boost-style')) return;

    var style = document.createElement('style');
    style.id = 'rs-search-boost-style';
    style.textContent =
      '.rs-search-boost{width:100%;display:grid;gap:12px}' +
      '.rs-search-boost-heading{display:block;font-size:11px;text-transform:uppercase;letter-spacing:.16em;line-height:1.2;color:rgba(255,255,255,.68);margin:0}' +
      '.rs-search-boost-list{display:grid;gap:10px;width:100%}' +
      '.rs-search-boost-card{display:grid;grid-template-columns:60px 1fr;gap:12px;align-items:center;width:100%;padding:10px;border:1px solid rgba(255,255,255,.12);border-radius:12px;background:rgba(255,255,255,.035);color:inherit;text-decoration:none}' +
      '.rs-search-boost-card:hover{border-color:#b6ff00;background:rgba(182,255,0,.07)}' +
      '.rs-search-boost-image{width:60px;height:60px;border-radius:9px;object-fit:cover;background:#111}' +
      '.rs-search-boost-copy{display:grid;gap:4px;min-width:0}' +
      '.rs-search-boost-title{color:#fff;font-weight:850;line-height:1.2;font-size:14px}' +
      '.rs-search-boost-meta{color:rgba(255,255,255,.62);font-size:12px;line-height:1.25;font-weight:650}' +
      '.rs-search-boost-meta strong{color:#b6ff00;font-weight:850}';

    document.head.appendChild(style);
  }

  function resultBox(form) {
    var sectionId = form.getAttribute('data-section-id');
    if (!sectionId) return null;
    return document.getElementById('PredictiveSearchResults-' + sectionId);
  }

  function removeOld(box) {
    var old = box.querySelector('[data-rs-search-boost]');
    if (old) old.remove();
  }

  function render(form) {
    var input = form.querySelector('input[type="search"]');
    var box = resultBox(form);

    if (!input || !box) return;

    var query = input.value.trim();
    removeOld(box);

    if (!query) return;

    styles();

    loadProducts().then(function (products) {
      if (query !== input.value.trim()) return;

      var searchTerm = norm(query);

      var matches = products
        .filter(function (p) {
          return p.searchable.indexOf(searchTerm) !== -1;
        })
        .slice(0, 8);

      if (!matches.length) return;

      removeOld(box);

      var wrap = document.createElement('div');
      wrap.className = 'rs-search-boost';
      wrap.setAttribute('data-rs-search-boost', '');

      var heading = document.createElement('p');
      heading.className = 'rs-search-boost-heading';
      heading.textContent = 'Rogue scent matches';

      var list = document.createElement('div');
      list.className = 'rs-search-boost-list';

      matches.forEach(function (p) {
        var link = document.createElement('a');
        link.className = 'rs-search-boost-card';
        link.href = p.url;

        var image = document.createElement('img');
        image.className = 'rs-search-boost-image';
        image.src = p.image || '';
        image.alt = p.title;
        image.loading = 'lazy';

        var copy = document.createElement('span');
        copy.className = 'rs-search-boost-copy';

        var title = document.createElement('span');
        title.className = 'rs-search-boost-title';
        title.textContent = p.title;

        copy.appendChild(title);

        if (p.brand) {
          var brand = document.createElement('span');
          brand.className = 'rs-search-boost-meta';
          brand.innerHTML = '<strong>Brand:</strong> ' + p.brand;
          copy.appendChild(brand);
        }

        if (p.inspired) {
          var inspired = document.createElement('span');
          inspired.className = 'rs-search-boost-meta';
          inspired.innerHTML = '<strong>Inspired by:</strong> ' + p.inspired;
          copy.appendChild(inspired);
        }

        link.appendChild(image);
        link.appendChild(copy);
        list.appendChild(link);
      });

      wrap.appendChild(heading);
      wrap.appendChild(list);
      box.prepend(wrap);
      form.setAttribute('results', '');
    });
  }

  function initForm(form) {
    if (form.dataset.rsSearchBoost === 'true') return;
    form.dataset.rsSearchBoost = 'true';

    var input = form.querySelector('input[type="search"]');
    if (!input) return;

    var timer;

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        render(form);
      }, 450);

      setTimeout(function () {
        render(form);
      }, 900);
    }

    input.addEventListener('input', schedule);
    input.addEventListener('focus', schedule);
  }

  function init() {
    document.querySelectorAll('form[is="predictive-search"]').forEach(initForm);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  setTimeout(init, 800);
})();